// extracted by mini-css-extract-plugin
export default {"l_EditIcon_main":"EditIcon_l_EditIcon_main__cKltv","l_EditIcon_iconImg":"EditIcon_l_EditIcon_iconImg__PhRjb"};